// Firebase config
export const firebaseConfig = {
	apiKey: 'AIzaSyB6CnX6_n0e6TDQdtGklZMzPxYnYZX5828',
	authDomain: 'pilu-e73b8.firebaseapp.com',
	projectId: 'pilu-e73b8',
	storageBucket: 'pilu-e73b8.appspot.com',
	messagingSenderId: '655711578396',
	appId: '1:655711578396:web:b7f1ffe8173600a95272d9',
};

// Storage URL
export const bucketRef = 'gs://pilu-e73b8.appspot.com';
